import { SkeletonBlock } from './skeleton.styles';

const Skeleton = ({
	width,
	height,
	radius,
	minWidth,
	minHeight,
	className,
}) => (
	<SkeletonBlock
		className={className}
		$width={width}
		$height={height}
		$radius={radius}
		$minWidth={minWidth}
		$minHeight={minHeight}
		aria-hidden="true"
	/>
);

export default Skeleton;
